import { createContext } from 'react';
const SelectContext = createContext({});
export default SelectContext;
